import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Divider, Modal, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { colors } from '../../assets/styles/colors';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 640,
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: 2,
  paddingLeft: 4,
  paddingRight: 4,
};

const PartnerDeleteWarning = ({
  isLoading,
  hasTxns,
  partner,
  modalVisible,
  onModalClose,
  onConfirmDeletion,
}: any) => {
  const { t } = useTranslation();

  if (!modalVisible) return null;
  return (
    <Modal
      open={modalVisible}
      onClose={onModalClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <Box sx={style}>
        <Stack pb={1}>
          <Typography
            sx={{ fontSize: 20, color: colors.red500, fontWeight: 'bold' }}>
            {hasTxns
              ? t('partner.deleteMsg.warningTitle2')
              : t('partner.deleteMsg.warningTitle')}
          </Typography>
        </Stack>
        <Divider />

        <Stack py={1} gap={3}>
          <Typography sx={{ fontSize: 18 }}>
            {hasTxns
              ? t('partner.deleteMsg.warningSubtitle2')
              : t('partner.deleteMsg.warningSubtitle')}
          </Typography>

          <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
            <Grid xs={4} sx={{ fontWeight: 'bold' }}>
              Code
            </Grid>
            <Grid xs={8}>{partner.code} </Grid>

            <Grid xs={4} sx={{ fontWeight: 'bold' }}>
              Partner Name
            </Grid>
            <Grid xs={8}>{partner.name}</Grid>

            {partner.phoneNumber && (
              <>
                <Grid xs={4} sx={{ fontWeight: 'bold' }}>
                  Phone Number
                </Grid>
                <Grid xs={8}>{partner.phoneNumber}</Grid>
              </>
            )}
          </Grid>
        </Stack>

        <Divider />

        <Stack direction="row" justifyContent={'flex-end'} spacing={4} pt={2}>
          <Button
            color="inherit"
            variant="contained"
            size="large"
            onClick={onModalClose}>
            {t('partner.deleteMsg.cancelBtn')}
          </Button>

          {!hasTxns && (
            <Button
              color="error"
              variant="contained"
              size="large"
              onClick={() => onConfirmDeletion(partner)}>
              {t('partner.deleteMsg.confirmBtn')}
            </Button>
          )}
        </Stack>
      </Box>
    </Modal>
  );
};

export default PartnerDeleteWarning;
